module.exports = __webpack_public_path__ + "static/media/checkmark.15e52ab9.svg";